import { Link } from 'react-router-dom';
import { useCallStatus } from '../../api/projects.js';
import { Card, buttonClass } from '../../components/ui.js';
import { ProjectDashboardDetails } from '../../components/ProjectDashboard.js';
import { useProjectContext } from './ProjectShell.js';

/** The founder's dashboard tab: talk-to-us call actions, then progress. */
export function DashboardPage() {
  const { project } = useProjectContext();
  return (
    <div className="flex flex-col gap-6">
      <CallActions projectId={project.id} />
      <ProjectDashboardDetails projectId={project.id} />
    </div>
  );
}

/**
 * The tier's bookable calls. Each link is always clickable: with bookings left
 * it opens the booking page; when the type is used up or not on the plan, it
 * routes to the membership page to upgrade (rather than greying out).
 */
function CallActions({ projectId }: { projectId: string }) {
  const status = useCallStatus(projectId);
  if (status.isPending || status.isError || !status.data) return null;
  const { options } = status.data;
  if (options.length === 0) return null;

  return (
    <Card>
      <h2 className="mb-3 font-title text-xl tracking-wide">Talk to us</h2>
      <div className="flex flex-col gap-2">
        {options.map((o) => {
          const label = `Request a ${o.label.toLowerCase()}`;
          const bookable = o.remaining > 0 && o.link.length > 0;
          const noLinkYet = o.remaining > 0 && o.link.length === 0;
          return (
            <div key={o.key} className="flex flex-wrap items-center gap-3">
              {bookable ? (
                <a
                  href={o.link}
                  target="_blank"
                  rel="noreferrer"
                  className={buttonClass('secondary')}
                >
                  {label}
                </a>
              ) : noLinkYet ? (
                <button
                  disabled
                  title="Booking link coming soon"
                  className={`${buttonClass('secondary')} cursor-not-allowed opacity-40`}
                >
                  {label}
                </button>
              ) : (
                // Used up this month, or a pure upsell (cap 0): send to upgrade.
                <Link to="/membership" className={buttonClass('secondary')}>
                  {label}
                </Link>
              )}
              <span className="text-sm opacity-60">
                {o.maxPerMonth > 0
                  ? `${o.remaining} of ${o.maxPerMonth} left this month`
                  : 'Available on a higher plan'}
              </span>
            </div>
          );
        })}
      </div>
    </Card>
  );
}
